import { IconProps } from './icons-props';

function SendFillIcon({ className, width = 32, height = 32 }: IconProps) {
    return (
        <svg
            fill='none'
            width={width}
            height={height}
            className={className}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18.0698 8.50989L9.50978 4.22989C3.75978 1.34989 1.39978 3.70989 4.27978 9.45989L5.14978 11.1999C5.39978 11.7099 5.39978 12.2999 5.14978 12.8099L4.27978 14.5399C1.39978 20.2899 3.74978 22.6499 9.50978 19.7699L18.0698 15.4899C21.9098 13.5699 21.9098 10.4299 18.0698 8.50989ZM14.8398 12.7499H9.43977C9.02978 12.7499 8.68977 12.4099 8.68977 11.9999C8.68977 11.5899 9.02978 11.2499 9.43977 11.2499H14.8398C15.2498 11.2499 15.5898 11.5899 15.5898 11.9999C15.5898 12.4099 15.2498 12.7499 14.8398 12.7499Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default SendFillIcon;

